const ICONS = {
    success: "bi-check-circle",
    danger: "bi-exclamation-circle",
    error: "bi-exclamation-circle",
    info: "bi-info-circle",
    warning: "bi-exclamation-triangle"
}

const DEFAULT_DURATION_MS = 2500

// `message` is the toast title. Pass `subtitle` for an optional second line;
// without one the toast is a single line. Pass `action: { label, onClick }`
// for one inline button ("Undo"); clicking it runs onClick and dismisses.
export function showSystemToast(message, { level = "success", duration = DEFAULT_DURATION_MS, subtitle, action } = {}) {
    if (!message) return null

    const sub = subtitle || null

    document.querySelectorAll("[data-system-toast]").forEach((node) => node.remove())

    const wrapper = document.createElement("div")
    wrapper.className = "milestone-ack-toast system-toast"
    wrapper.dataset.systemToast = "true"

    const ack = document.createElement("div")
    ack.className = "milestone-ack system-toast-ack"
    ack.setAttribute("role", "alert")

    const body = document.createElement("div")
    body.className = "milestone-ack-body"

    const icon = document.createElement("i")
    icon.className = `bi ${ICONS[level] || ICONS.info} milestone-ack-icon`
    icon.setAttribute("aria-hidden", "true")

    const textWrap = document.createElement("div")
    const text = document.createElement("p")
    text.className = "milestone-ack-text system-toast-title mb-0"
    text.textContent = message
    textWrap.appendChild(text)

    if (sub) {
        const subEl = document.createElement("p")
        subEl.className = "system-toast-subtitle mb-0"
        subEl.textContent = sub
        textWrap.appendChild(subEl)
    }

    body.appendChild(icon)
    body.appendChild(textWrap)
    if (action?.label) {
        const btn = document.createElement("button")
        btn.type = "button"
        btn.className = "system-toast-action"
        btn.textContent = action.label
        btn.addEventListener("click", () => {
            wrapper.remove()
            action.onClick?.()
        })
        body.appendChild(btn)
    }
    ack.appendChild(body)
    wrapper.appendChild(ack)
    document.body.appendChild(wrapper)

    if (duration > 0) {
        setTimeout(() => wrapper.remove(), duration)
    }

    return wrapper
}
